<template>
	<div>
		<p class='w-[200px] text-14'>{{ help }}</p>

		<!-- <div class='flex items-center justify-center h-[170px]'>
			<p class='text-14 text-grey-900 text-center'>
				<slot name='create'>Use the 
					<button class='bg-black h-4 w-4 inline' @click='() => { this.$event.$emit("timeline-create-menu", { toggle: true }) }'>
						<div class='flex items-center justify-center'>
	                    	<IconPlusS class='h-2.5 w-2.5 stroke-white' />    
	                    </div>
	                </button>
				button to create<br />your first {{ create }}</slot>
			</p>
		</div> -->
	</div>
</template>

<script>
	export default {
		props: {
			help: String,
			create: String
		}
	}
</script>